import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncNewsEntryList = lazy(() => import('~/containers/NewsEntryList'));

export default [
  <Route path="/news-entries">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncNewsEntryList />
    </Suspense>
  </Route>,
];
